import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="notfound-container">
      <SEO 
        title="Page Not Found (404) | Vektrixo Digital" 
        description="The page you are looking for has been moved, deleted, or does not exist in our digital grid."
        canonical="https://www.vektrixo.com/404"
        noindex={true}
      />
      {/* Ambient background glowing orbs */}
      <div className="notfound-glow-orb orb-left"></div>
      <div className="notfound-glow-orb orb-right"></div>
      
      <div className="notfound-box">
        <AlertTriangle size={64} className="notfound-icon" />
        <h1 className="notfound-title">404</h1>
        <h2 className="notfound-subtitle">Coordinates Not Found</h2>
        <p className="notfound-text">
          The page you are looking for has been moved, deleted, or does not exist in our digital grid.
        </p>
        <Link to="/" className="notfound-btn">
          <ArrowLeft size={18} /> RETURN TO HOME
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
